module.exports = __webpack_public_path__ + "cc65b1f4e9b534b171cd4a29eacd1b88.png";